"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionableToastList = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("../../styles");
var ActionableToast_1 = require("./ActionableToast");
function ActionableToastList(props) {
    var data = props.data, _a = props.marginTop, marginTop = _a === void 0 ? 1 : _a, _b = props.marginRight, marginRight = _b === void 0 ? '1.5rem' : _b;
    var classes = styles_1.useStyles(function () { return createStyles(marginTop, marginRight); }).classes;
    return (data.length > 0 && (react_1.default.createElement("div", { className: classes.container }, data.map(function (toast) { return (react_1.default.createElement(ActionableToast_1.ActionableToast, { key: toast.id, id: toast.id, message: toast.message, title: toast.title, buttonLabel: toast.buttonLabel, onClose: toast.onClose, newToast: toast.newToast, action: toast.action, removeToast: toast.removeToast, secondsVisible: toast.secondsVisible })); }))));
}
exports.ActionableToastList = ActionableToastList;
var createStyles = function (marginTop, marginRight) { return ({
    container: {
        position: 'fixed',
        padding: '0',
        paddingTop: '1rem',
        width: '100%',
        maxWidth: '17rem',
        maxHeight: '100vh',
        overflow: 'hidden',
        top: marginTop + "rem",
        right: marginRight,
        zIndex: 20,
    },
}); };
//# sourceMappingURL=ActionableToastList.js.map